
const initialeState = {
    counter : 0,
    display: 'none'
}


const NotificationReducer = (state=initialeState, action) => {
    switch (action.type) {
        case 'READ_NOTIFICATION':
            return {
                ...state,
                counter: state.counter -1
            }
            break;
        case  'TOGGLE_NOTIFICATIONS':
            return {
                ...state,
                display : (state.display == 'block')?'none':'block'
            }

        case 'UPDATE_NOTIFICATIONS_COUNT':
            return {
                ...state,
                counter: action.value
            }
            break;
        case 'GET_UNREAD_NOTIFICATIONS':
            return {
                ...state,
                unread : action.data,
            }
            break;
        default:
            return state
    }
}

export default NotificationReducer
